<template>
    <main class="authorization-content authorization-content_bg">
      <div class="autorization">
        <div class="autorization__body popup box bg-white">
          <form id="password-recovery-form" @submit.prevent="submitForm" name="password-recovery-form" method="post">
            <div class="popup__header">
              <div class="popup__title section__title section__title_style3">{{ $t("passwordRecovery") }}</div>
              <div class="popup__logo svg-icon" aria-hidden="true">
                <svg role="img" width="63" height="24" aria-hidden="true">
                  <use xlink:href="#svg-logo-mobile"></use>
                </svg>
              </div>
            </div>
            <div class="popup__body">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-email-recovery">{{ $t("email") }}</label>
                <input class="form-control" :disabled="!!phone" :class="{is_invalid: v$.email.$error}" type="email" v-model.trim="email" name="user-email-recovery" id="user-email-recovery" :placeholder='$t("email")'>
                <div class="form-validator" :class="{is_invalid: v$.email.$error}">{{ $t("incorrectEmail") }}</div>
              </div>
              <div class="or_text">
                {{$t("or")}}
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-tel-recovery">{{ $t("phoneNumber") }}</label>
                <input class="form-control" :disabled="!!email" v-mask="'+7 (###) ### ## ##'" type="tel" :class="{is_invalid: v$.phone.$error}" v-model.trim="phone" name="user-tel-recovery" id="user-tel-recovery" placeholder="+7 - - - - - - - - - -">
                <div class="form-validator" :class="{is_invalid: v$.phone.$error}">{{ $t("incorrectPhoneNumber") }}</div>
              </div>
            </div>
            <div class="popup__footer">
              <div class="autorization__descr color-green" v-if="answerStatus === 200">{{ $t("recoverySuccess") }}</div>
              <div class="autorization__descr color-red" v-if="answerStatus === 404">{{ $t("userNotFound") }}</div>
              <div class="autorization__descr color-red" v-else-if="answerStatus !== '' && answerStatus !== 200">{{ $t("recoveryError") }}</div>
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-auto order-sm-last">
                  <button class="btn btn_default btn_white" type="submit">{{ $t("send") }}</button>
                </div>
                <div class="col-12 col-sm-auto"><router-link class="link link_gray" to="/login">{{ $t("cancel") }}</router-link></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>
</template>
<script>
import useValidate from "@vuelidate/core";
import { email, minLength, maxLength } from "@vuelidate/validators";

import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  data(){
    return {
      v$: useValidate(),
      email: '',
      phone: '',
      answerStatus: ''
    }
  },
  validations() {
  	return {
  		email: { email },
      phone: { minLength: minLength(10), maxLength: maxLength(18)}
  	}
  },
  methods: {
    ...mapActions({
      recoveryPassword: 'authorization/recoveryPassword',
      recoveryPasswordPhone: 'authorization/recoveryPasswordPhone',
    }),
    submitForm() {
      this.v$.$validate() 
  		if (!this.v$.$error) { 
        if (this.email){
          this.recoveryPassword({"email": this.email.toLowerCase()}).then((res) => {
            this.answerStatus = res
          })
        }else if(this.phone){
          let phoneNum = this.phone
          if (phoneNum.startsWith("+7") && phoneNum.includes("(")){
            phoneNum = phoneNum.replace(/\s+/g, '').replace('(', '').replace(')', '').slice(2);
          }
          this.recoveryPasswordPhone({"phone": phoneNum}).then((res) => {
            this.answerStatus = res
          })
        }else{
          this.answerStatus = "error"
        }
  		}
    }
  }
}
</script>
<style scoped>
  .is_invalid{
    border: 1px solid #dd2727;
    opacity: 1;
    visibility: inherit;
  }
  .autorization__descr{
    font-size: .8em;
  }
  .form-validator{
    font-size: .8em;
  }
  .or_text{
    margin: -1em 0 5px 5px;
    color: #8e8e8e;
    font-size: 0.95em;
  }
  @media (max-width: 767px) {
    .or_text{
      margin: -.5em 0 5px 5px;
    }
  }
</style>